import { pdfjs } from "react-pdf";
import workerUrl from "file-loader!pdfjs-dist/legacy/build/pdf.worker.min.mjs";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";

// Webpack selects the legacy API with its URL.parse polyfill; bundle its matching worker.
pdfjs.GlobalWorkerOptions.workerSrc = workerUrl;

export const pdfOptions = { isEvalSupported: false };
export { Document, Page } from "react-pdf";
